import { useTranslation } from "react-i18next";
import { Checkbox, FormControl, FormControlLabel, FormGroup } from "@mui/material";
import Button from "components/Button";
import styles from "../styles.module.scss";
import sharingStyles from "./Step2Sharing.module.scss";
import { useWizard } from "../WizardContext";

const Step2Sharing = () => {
  const { t } = useTranslation();
  const { settings, patchSettings, goNext } = useWizard();

  const sharePublic = settings.sharePublic ?? false;
  const shareInternal = settings.shareInternal ?? false;

  return (
    <>
      <FormControl className={styles.addressBookCheckboxes}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={shareInternal}
                onChange={(e) => patchSettings({ shareInternal: e.target.checked })}
              />
            }
            label={
              <span>
                <strong>{t("settings.shareInNotaUp")}</strong>
                <br />
                <span className={sharingStyles.checkDesc}>
                  {t("contactFormWizard.steps.sharing.internalDesc")}
                </span>
              </span>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={sharePublic}
                onChange={(e) => patchSettings({ sharePublic: e.target.checked })}
              />
            }
            label={
              <span>
                <strong>{t("settings.shareOnESzyfrowane")}</strong>
                <br />
                <span className={sharingStyles.checkDesc}>
                  {t("contactFormWizard.steps.sharing.publicDesc")}
                </span>
              </span>
            }
          />
        </FormGroup>
      </FormControl>

      <div className={styles.stepActions}>
        <Button text={t("common.next")} onClick={goNext} />
      </div>
    </>
  );
};

export default Step2Sharing;
